import { useQuery } from "@tanstack/react-query";
import { useAppData } from "../context/Contexts";
import { withPartNumberSkuQuery } from "../helpers/helpers";

const useCaptionsQuery = () => {
    const { currentAppData, setCurrentAppData } = useAppData();

    // fetch function defined first so queryFn can safely call it
    const fetchCaptions = async (pageParam = null) => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            };

            const response = await fetch(withPartNumberSkuQuery("https://shopbiz.wearevisum.com/api/v1/captions"), requestOptions)
                .catch(error => {
                    console.error('captions fetch error', error);
                    const fallback = {};
                    setCurrentAppData(prevState => ({ ...prevState, captions: fallback }));
                    return null;
                });

            if (!response) {
                // ensure we never return undefined to react-query
                const fallback = {};
                setCurrentAppData(prevState => ({ ...prevState, captions: fallback }));
                return fallback;
            }

            let data;
            try {
                data = await response.json();
            } catch (e) {
                console.error('captions json parse error', e);
                data = { data: {} };
            }

            const payload = data && data.data ? data.data : {};
            setCurrentAppData(prevState => ({ ...prevState, captions: payload }));

            return payload;
        } catch (e) {
            console.error('unexpected captions error', e);
            const fallback = {};
            setCurrentAppData(prevState => ({ ...prevState, captions: fallback }));
            return fallback;
        }
    };

    const {
        status,
        data,
        error,
        isFetching,
        refetch
    } = useQuery({
        queryKey: ['captions'],
        refetchOnWindowFocus: false,
        enabled: false,
        queryFn: () => fetchCaptions(),
    });

    const Shopify = window.Shopify || {};
    Shopify.country = Shopify.country || 'US';

    return {
        captions_status: status,
        captions_data: data,
        captions_error: error,
        captions_isFetching: isFetching,
        captions_refetch: refetch
    };
};

export default useCaptionsQuery;
